
import { Component, Vue } from 'vue-property-decorator'
// import { TimelineLite } from 'gsap'

@Component
export default class Animation extends Vue {
  // tl: any

  // enter(el, done) {
  //   console.log('enter', el)
  //   // console.log(el, done)
  //   // this.timeline.from(this.$refs.curtain2, 0.5, { width: '100%', onComplete: done })
  //   done()
  // }

  // leave(el, done) {
  //   // console.log('leave', el, this.$refs.pheader)
  //   this.tl.to(this.$refs.pheader, 0.5, { x: -50, onComplete: done })
  //   // done()
  // }
}

